import { useMutation } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';


export interface AddTreatmentsValuePayload{
    projectId:string;
   featureId:string;
   treatmentId:string;
   contextId:string;
   contextValues:string[];
}


const addTreatmentsValue = async (payload:AddTreatmentsValuePayload) => {
  try {
    const url = paths.addTreatmentsValue();
    const response = await axiosInstance.post(url, {input: payload});
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
  
};

export const useAddTreatmentsValue = () => {
  return useMutation(addTreatmentsValue);
}; 